export default "__VITE_ASSET__CNKM6SxJ__"